<template>
    <!-- Terms modal popup -->
    <div class="modal fade terms-modal-popup" id="terms-modal" tabindex="-1" role="dialog" aria-labelledby="terms-modal-label" aria-hidden="true">
        <div class="modal-dialog" role="document">
            <div class="modal-content border-0 mt-3 rounded-3">
                <div class="modal-header mx-2 justify-content-between">
                    <h5 class="modal-title mt-3" id="terms-modal-label"><img src="/img/site/icons/info-grey-outline.svg" alt="Terms and Conditions" title="Terms and Conditions" width="16" height="16">  Terms & Conditions:</h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div class="modal-body mx-2 mb-2">
                    <ul>
                        <li><strong>Cash Back</strong> or discount applies on selected vehicles only.</li>
                        <li>This vehicle is eligible for the <strong>Cash Back</strong> or Discount promotion. Choose to either receive ${{dollar_format(termsModalSavings)}} <strong>Cash Back</strong> and pay full vehicle price ${{dollar_format(termsModalFullPrice)}} OR ${{dollar_format(termsModalSavings)}} discount on full vehicle price.</li>
                        <li><strong>Cash Back</strong> will not be paid in cash but will be by direct credit to an appointed bank account 5 days after purchase or 10 days after the finance contract is signed.</li>
                        <li>If the <strong>Cash Back</strong> amount is included in the finance agreement, it will form as part of the loan and incur interest over the term of the loan.</li>
                        <li>This offer does not apply to any other specials/promotions and is for retail customers only, wholesale and trade buyers are excluded.</li>
                        <li>All finance contracts are subject to finance company approval and responsible lending obligations.</li>
                    </ul>
                    <div class="modal-footer mx-2 border-0 d-flex justify-content-center">
                        <button type="button" class="btn btn-primary rounded-5" data-bs-dismiss="modal">Okay, I understand</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>

export default {
    props: ['termsModalSavings', 'termsModalFullPrice'],

    methods: {
        dollar_format(value, decimal) {
            let parsedNumber = parseFloat(value);
            if (_.isNaN(parsedNumber)) {
                return '0';
            }
            return parsedNumber.toFixed(decimal).replace(/(.)(?=(\d{3})+$)/g,'$1,');
        },
    }
}
</script>
